module.exports = __webpack_public_path__ + "img/小島萌.8a0398c5.jpg";